import "core-js/stable";
import "regenerator-runtime/runtime";

import "upn-component-button-reset.css";
